import { useEffect } from "react";
import { MemoryRouter, Routes, Route, Outlet, useNavigate, useLocation, UNSAFE_LocationContext, UNSAFE_RouteContext } from "react-router-dom";
import { protectedRoutes } from "@/appRoutes";
import { useSplit, registerPaneNavigate, setPaneLocation } from "@/lib/splitScreen";

// React Router refuses a <Router> inside another; the pane IS a second router by design, so the
// outer location/route contexts are blanked right above it and the MemoryRouter provides its own.
const NO_ROUTE = { outlet: null, matches: [], isDataRoute: false };

// Hands the pane's navigate() to the split store and mirrors its location for the header title.
function PaneBridge() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => registerPaneNavigate(navigate), [navigate]);
  useEffect(() => { setPaneLocation(location); }, [location]);
  return null;
}

function PaneShell() {
  return (
    <div className="top-layout-content split-pane w-full min-w-0" data-testid="split-pane-content">
      <Outlet />
    </div>
  );
}

// Right half of the split screen: an in-memory copy of the signed-in app. Starts on the page the user was on.
export default function SplitPane() {
  const { on, initial, key } = useSplit();
  if (!on || !initial) return null;
  return (
    <UNSAFE_LocationContext.Provider value={null}>
      <UNSAFE_RouteContext.Provider value={NO_ROUTE}>
        <MemoryRouter key={key} initialEntries={[initial]}>
          <PaneBridge />
          <Routes>
            <Route path="/" element={<PaneShell />}>
              {protectedRoutes()}
            </Route>
          </Routes>
        </MemoryRouter>
      </UNSAFE_RouteContext.Provider>
    </UNSAFE_LocationContext.Provider>
  );
}
